import { render } from "./OrderAgreement.vue?vue&type=template&id=01babdaf&scoped=true&ts=true"
import script from "./OrderAgreement.vue?vue&type=script&lang=ts"
export * from "./OrderAgreement.vue?vue&type=script&lang=ts"

import "./OrderAgreement.vue?vue&type=style&index=0&id=01babdaf&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01babdaf"]])

export default __exports__